import { createContext, useContext } from 'react';
import { RegisterJourneyEnum } from '../steps/registering/register-journey.enum';
import { isUserInTestBucket } from '@at/ab-test-utils';
export var SignInMode;
(function (SignInMode) {
    SignInMode[SignInMode["SignIn"] = 0] = "SignIn";
    SignInMode[SignInMode["CreateAccount"] = 1] = "CreateAccount";
    SignInMode[SignInMode["RequiringVerification"] = 2] = "RequiringVerification";
    SignInMode[SignInMode["TwoFactorAsk"] = 3] = "TwoFactorAsk";
    SignInMode[SignInMode["TwoFactorRequired"] = 4] = "TwoFactorRequired";
    SignInMode[SignInMode["TwoFactorRequiredAlreadySignedIn"] = 5] = "TwoFactorRequiredAlreadySignedIn";
    SignInMode[SignInMode["TwoFactorRemoval"] = 6] = "TwoFactorRemoval";
    SignInMode[SignInMode["TwoFactorCreateAccount"] = 7] = "TwoFactorCreateAccount";
    SignInMode[SignInMode["SoftRegistration"] = 8] = "SoftRegistration";
    SignInMode[SignInMode["TwoFactorSoftRegistration"] = 9] = "TwoFactorSoftRegistration";
    SignInMode[SignInMode["SavedAdvert"] = 10] = "SavedAdvert";
    SignInMode[SignInMode["RemoveSavedAdvert"] = 11] = "RemoveSavedAdvert";
})(SignInMode || (SignInMode = {}));
export var FocusField;
(function (FocusField) {
    FocusField["Username"] = "username";
    FocusField["Password"] = "password";
})(FocusField || (FocusField = {}));
export var LogInActionsTypes;
(function (LogInActionsTypes) {
    LogInActionsTypes["UPDATE_STEP"] = "UPDATE_STEP";
    LogInActionsTypes["UPDATE_USERNAME"] = "UPDATE_USERNAME";
    LogInActionsTypes["UPDATE_PASSWORD"] = "UPDATE_PASSWORD";
    LogInActionsTypes["UPDATE_PASSWORD_OK"] = "UPDATE_PASSWORD_OK";
    LogInActionsTypes["RESET_STATE"] = "RESET_STATE";
    LogInActionsTypes["REGISTERING"] = "REGISTERING";
    LogInActionsTypes["BEGIN_SOFT_REGISTER_FLOW"] = "BEGIN_SOFT_REGISTER_FLOW";
    LogInActionsTypes["UPDATE_SOFT_REGISTERING"] = "UPDATE_SOFT_REGISTERING";
    LogInActionsTypes["MARKETING_OPT_IN"] = "MARKETING_OPT_IN";
    LogInActionsTypes["UPDATE_CAPTCHA"] = "UPDATE_CAPTCHA";
    LogInActionsTypes["UPDATE_SERVER_ERROR"] = "UPDATE_SERVER_ERROR";
    LogInActionsTypes["UPDATE_SERVER_MESSAGE"] = "UPDATE_SERVER_MESSAGE";
    LogInActionsTypes["UPDATE_TRADE_USER"] = "UPDATE_TRADE_USER";
    LogInActionsTypes["GO_BACK_TO"] = "GO_BACK_TO";
    LogInActionsTypes["UPDATE_COMPLETED_LOGIN"] = "UPDATE_COMPLETED_LOGIN";
    LogInActionsTypes["UPDATE_TWO_FACTOR_ENABLED"] = "UPDATE_TWO_FACTOR_ENABLED";
    LogInActionsTypes["UPDATE_TWO_FACTOR_NUMBER"] = "UPDATE_TWO_FACTOR_NUMBER";
    LogInActionsTypes["UPDATE_TWO_FACTOR_NUMBER_HINT"] = "UPDATE_TWO_FACTOR_NUMBER_HINT";
    LogInActionsTypes["UPDATE_DATABASE_ID"] = "UPDATE_DATABASE_ID";
    LogInActionsTypes["UPDATE_TWO_FACTOR_STATE"] = "UPDATE_TWO_FACTOR_STATE";
    LogInActionsTypes["UPDATE_TWO_FACTOR_SETUP"] = "UPDATE_TWO_FACTOR_SETUP";
    LogInActionsTypes["UPDATE_TWO_FACTOR_REMEMBER_ME"] = "UPDATE_TWO_FACTOR_REMEMBER_ME";
    LogInActionsTypes["UPDATE_ACCOUNT_LOCKED"] = "UPDATE_ACCOUNT_LOCKED";
    LogInActionsTypes["UPDATE_SIGNIN_MODE"] = "UPDATE_SIGNIN_MODE";
    LogInActionsTypes["UPDATE_USER_TOKEN"] = "UPDATE_USER_TOKEN";
    LogInActionsTypes["BATCH_UPDATE_STATE"] = "BATCH_UPDATE_STATE";
    LogInActionsTypes["UPDATE_FOCUS_FIELD"] = "UPDATE_FOCUS_FIELD";
})(LogInActionsTypes || (LogInActionsTypes = {}));
export var LogInStep;
(function (LogInStep) {
    LogInStep[LogInStep["LoginNav"] = 0] = "LoginNav";
    LogInStep[LogInStep["LoginNav_featureFlag"] = 1] = "LoginNav_featureFlag";
    LogInStep[LogInStep["ReturningUser"] = 2] = "ReturningUser";
    LogInStep[LogInStep["Username"] = 3] = "Username";
    LogInStep[LogInStep["UsernameMagicEmailLink"] = 4] = "UsernameMagicEmailLink";
    LogInStep[LogInStep["UsernameResetPassword"] = 5] = "UsernameResetPassword";
    LogInStep[LogInStep["UsernamePassword"] = 6] = "UsernamePassword";
    LogInStep[LogInStep["Password"] = 7] = "Password";
    LogInStep[LogInStep["EnterPassword_featureFlag"] = 8] = "EnterPassword_featureFlag";
    LogInStep[LogInStep["MagicLinkEmail"] = 9] = "MagicLinkEmail";
    LogInStep[LogInStep["ForgottenPassword"] = 10] = "ForgottenPassword";
    LogInStep[LogInStep["CheckEmailResetPassword"] = 11] = "CheckEmailResetPassword";
    LogInStep[LogInStep["PasswordReset"] = 12] = "PasswordReset";
    LogInStep[LogInStep["ChangePassword"] = 13] = "ChangePassword";
    LogInStep[LogInStep["Register"] = 14] = "Register";
    LogInStep[LogInStep["MarketingOptIn"] = 15] = "MarketingOptIn";
    LogInStep[LogInStep["TiredOfPasswords"] = 16] = "TiredOfPasswords";
    LogInStep[LogInStep["CreatePassword"] = 17] = "CreatePassword";
    LogInStep[LogInStep["CreatePassword_featureFlag"] = 18] = "CreatePassword_featureFlag";
    LogInStep[LogInStep["CreateUsername"] = 19] = "CreateUsername";
    LogInStep[LogInStep["PasswordUpdateCompleted"] = 20] = "PasswordUpdateCompleted";
    LogInStep[LogInStep["SoftRegistration"] = 21] = "SoftRegistration";
    LogInStep[LogInStep["SoftRegistrationOptions"] = 22] = "SoftRegistrationOptions";
    LogInStep[LogInStep["Welcome"] = 23] = "Welcome";
    LogInStep[LogInStep["WelcomeBack"] = 24] = "WelcomeBack";
    LogInStep[LogInStep["UpdatePassword"] = 25] = "UpdatePassword";
    LogInStep[LogInStep["VerifyAccountFailed"] = 26] = "VerifyAccountFailed";
    LogInStep[LogInStep["CheckEmailActivateAccount"] = 27] = "CheckEmailActivateAccount";
    LogInStep[LogInStep["Verify"] = 28] = "Verify";
    LogInStep[LogInStep["TwoFactorConfigAsk"] = 29] = "TwoFactorConfigAsk";
    LogInStep[LogInStep["TwoFactorChallenge"] = 30] = "TwoFactorChallenge";
    LogInStep[LogInStep["TwoFactorConfigPhoneNumber"] = 31] = "TwoFactorConfigPhoneNumber";
    LogInStep[LogInStep["TwoFactorConfigConfirmation"] = 32] = "TwoFactorConfigConfirmation";
    LogInStep[LogInStep["TwoFactorProblem"] = 33] = "TwoFactorProblem";
    LogInStep[LogInStep["TwoFactorRemove"] = 34] = "TwoFactorRemove";
    LogInStep[LogInStep["SignInProblem"] = 35] = "SignInProblem";
    LogInStep[LogInStep["CheckEmailCreatePassword"] = 36] = "CheckEmailCreatePassword";
    LogInStep[LogInStep["ExpiredLink"] = 37] = "ExpiredLink";
    LogInStep[LogInStep["ExpiredMagicLink"] = 38] = "ExpiredMagicLink";
    LogInStep[LogInStep["ExpiredResetPasswordLink"] = 39] = "ExpiredResetPasswordLink";
    LogInStep[LogInStep["ExpiredVerifyAccountLink"] = 40] = "ExpiredVerifyAccountLink";
})(LogInStep || (LogInStep = {}));
const isActiveABTest = isUserInTestBucket('csitT');
export const logInStateInitial = {
    appClassName: 'sign-in',
    dummy: false,
    journey: RegisterJourneyEnum.TOP_NAV,
    logInStep: isActiveABTest ? LogInStep.LoginNav_featureFlag : LogInStep.LoginNav,
    isRegistering: false,
    isSoftRegistered: false,
    username: '',
    password: '',
    databaseId: '',
    welcomePage: '',
    afterSignInUrl: '',
    redirectErrors: '',
    passwordOk: false,
    captchaToken: '',
    serverError: false,
    tradeUser: false,
    completedLogIn: false,
    allowUnverifiedSignIn: true,
    twoFactorEnabled: false,
    twoFactorSetup: false,
    rememberMe: false,
    accountLocked: false,
    focusField: FocusField.Username,
};
export const LogInContext = createContext({
    logInState: logInStateInitial,
    logInDispatch: () => { },
});
export const logInStateReducer = (logInState, action) => {
    const isActiveABTest = isUserInTestBucket('csitT');
    switch (action.type) {
        case LogInActionsTypes.UPDATE_STEP:
            return Object.assign(Object.assign({}, logInState), { logInStep: action.payload });
        case LogInActionsTypes.REGISTERING:
            return Object.assign(Object.assign({}, logInState), { logInStep: isActiveABTest ? LogInStep.LoginNav_featureFlag : LogInStep.LoginNav, isRegistering: action.payload !== undefined ? action.payload : true });
        case LogInActionsTypes.BEGIN_SOFT_REGISTER_FLOW:
            return Object.assign(Object.assign({}, logInState), { logInStep: LogInStep.SoftRegistrationOptions, isSoftRegistered: true });
        case LogInActionsTypes.UPDATE_SOFT_REGISTERING:
            return Object.assign(Object.assign({}, logInState), { isSoftRegistered: action.payload });
        case LogInActionsTypes.UPDATE_USERNAME:
            return Object.assign(Object.assign({}, logInState), { username: action.payload });
        case LogInActionsTypes.UPDATE_PASSWORD:
            return Object.assign(Object.assign({}, logInState), { password: action.payload });
        case LogInActionsTypes.UPDATE_PASSWORD_OK:
            return Object.assign(Object.assign({}, logInState), { passwordOk: action.payload });
        case LogInActionsTypes.MARKETING_OPT_IN:
            return Object.assign(Object.assign({}, logInState), { marketingOptIn: action.payload });
        case LogInActionsTypes.UPDATE_CAPTCHA:
            return Object.assign(Object.assign({}, logInState), { captchaToken: action.payload });
        case LogInActionsTypes.UPDATE_SERVER_ERROR:
            return Object.assign(Object.assign({}, logInState), { serverError: action.payload });
        case LogInActionsTypes.UPDATE_SERVER_MESSAGE:
            return Object.assign(Object.assign({}, logInState), { serverMessage: action.payload });
        case LogInActionsTypes.UPDATE_TRADE_USER:
            return Object.assign(Object.assign({}, logInState), { tradeUser: action.payload });
        case LogInActionsTypes.GO_BACK_TO:
            return Object.assign(Object.assign({}, logInState), { logInStep: action.payload, serverError: false, serverMessage: '' });
        case LogInActionsTypes.UPDATE_COMPLETED_LOGIN:
            return Object.assign(Object.assign({}, logInState), { completedLogIn: action.payload });
        case LogInActionsTypes.UPDATE_TWO_FACTOR_ENABLED:
            return Object.assign(Object.assign({}, logInState), { twoFactorEnabled: action.payload });
        case LogInActionsTypes.UPDATE_TWO_FACTOR_NUMBER:
            return Object.assign(Object.assign({}, logInState), { twoFactorNumber: action.payload });
        case LogInActionsTypes.UPDATE_TWO_FACTOR_NUMBER_HINT:
            return Object.assign(Object.assign({}, logInState), { twoFactorNumberHint: action.payload });
        case LogInActionsTypes.UPDATE_DATABASE_ID:
            return Object.assign(Object.assign({}, logInState), { databaseId: action.payload });
        case LogInActionsTypes.UPDATE_TWO_FACTOR_STATE:
            return Object.assign(Object.assign({}, logInState), { twoFactorState: action.payload });
        case LogInActionsTypes.UPDATE_TWO_FACTOR_SETUP:
            return Object.assign(Object.assign({}, logInState), { twoFactorSetup: action.payload });
        case LogInActionsTypes.UPDATE_TWO_FACTOR_REMEMBER_ME:
            return Object.assign(Object.assign({}, logInState), { rememberMe: action.payload });
        case LogInActionsTypes.UPDATE_ACCOUNT_LOCKED:
            return Object.assign(Object.assign({}, logInState), { accountLocked: action.payload });
        case LogInActionsTypes.UPDATE_SIGNIN_MODE:
            return Object.assign(Object.assign({}, logInState), { signInMode: action.payload });
        case LogInActionsTypes.UPDATE_USER_TOKEN:
            return Object.assign(Object.assign({}, logInState), { userToken: action.payload });
        case LogInActionsTypes.BATCH_UPDATE_STATE:
            return Object.assign(Object.assign({}, logInState), action.payload);
        case LogInActionsTypes.RESET_STATE:
            return Object.assign({}, logInStateInitial);
        default:
            return logInState;
    }
};
export const useLogInContext = () => useContext(LogInContext);
